export default "__VITE_ASSET__CdCY8pdo__"